import { render } from "./FormProductFinder.vue?vue&type=template&id=23cf5fca&scoped=true"
import script from "./FormProductFinder.vue?vue&type=script&lang=js"
export * from "./FormProductFinder.vue?vue&type=script&lang=js"

import "./FormProductFinder.vue?vue&type=style&index=0&id=23cf5fca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cf5fca"]])

export default __exports__